const Aecharts = a => require(['@/components/Aecharts'], a);

export default {
  name: 'AeMix',
  props: {
    data: {
      type: Array,
      default: () => [
        { id: 1, name: 'Bar', type: 'bar', value: [55, 43, 44, 32, 54, 31, 56, 23, 53, 12, 11, 21], color: '' },
        { id: 2, name: 'Line', type: 'line', value: [55, 43, 44, 32, 54, 31, 56, 23, 53, 12, 11, 21], color: '' },
      ]
    },
    type: { type: String, default: () => 'line' },
    smooth: { type: Boolean, default: () => true },
    xAxis: { type: Array, default: () => ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'] },
    grid: { type: Array, default: () => [] },
    cols: { type: String | Number, default: () => '' },
    color: { type: String, default: () => 'rgba(0, 0, 0, 0.68)' },
    fontSize: { type: String | Number, default: () => '12' },
    textStyle: { type: Object, default: () => ({}) },
    itemStyle: { type: Object, default: () => ({}) },
    legend: { type: Object, default: () => ({ show: true, left: 'right' }) },
    showTooltip: { type: Boolean, default: () => true },
    scrollOption: { type: Object, default: () => ({ height: 20 }) },
    backgroundColor: { type: String, default: () => 'rgba(0, 0, 0, 0)' },
  },
  data() {
    return {
      option: {},
      styles: {
        textStyle: {
          color: this.color,
          fontSize: parseInt(this.fontSize),
          ...this.textStyle,
        },
      },
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.create();
      },
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const series = this.data.map((a, b) => ({
        name: a.name || a.text || a.label || a.title || '匿名',
        data: a.data || a.value || a.number || [],
        type: a.type ? a.type : this.type,
        smooth: a.smooth || this.smooth, // 圆滑折线角度
        barWidth: a.barWidth || a.width || 18,
        itemStyle: {
          color: a.color || null,
          borderWidth: a.borderWidth || a.width || null,
          ...this.itemStyle,
        },
        areaStyle: { // 区域填充样式
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: 'rgba(58,132,255, 0.5)' }, // 0% 处的颜色
              { offset: 1, color: 'rgba(58,132,255, 0)' }, // 100% 处的颜色
            ],
            global: false, // 缺省为 false
          }
        },
        animationDelay: c => c * b * 100,
        ...a,
      }));
      this.option = {
        backgroundColor: this.backgroundColor,
        legend: {
          ...this.styles,
          ...this.legend,
        },
        grid: {
          show: false,
          top: (this.legend && this.legend.show) ? ((parseInt(this.fontSize) * 2.5).toFixed(2)) : parseInt(this.grid[0] || 0),
          right: parseInt(this.grid[1] || this.grid[0] || 0),
          bottom: parseInt(this.grid[2] || this.grid[0] || 0),
          left: parseInt(this.grid[3] || this.grid[1] || this.grid[0] || 0),
          containLabel: true,
          ...this.styles,
        },
        xAxis: [
          {
            boundaryGap: true,
            data: this.xAxis,
            splitLine: { show: false },
            axisLabel: {
              ...this.styles,
            },
          },
        ],
        yAxis: [
          {
            axisLine: { show: true },
            splitLine: { show: false },
            splitArea: { show: false },
            axisLabel: {
              ...this.styles,
            },
          },
        ],
        series,
        dataZoom: this.cols && (this.xAxis.length > parseInt(this.cols) && ([
          {
            show: true,
            type: 'slider',
            orient: 'horizontal',
            xAxisIndex: [0],
            zoomLock: true,
            startValue: 0,
            maxValueSpan: (parseInt(this.cols) - 1),
            ...this.scrollOption
          },
          { type: 'inside', xAxisIndex: [0], zoomOnMouseWheel: false, moveOnMouseMove: true, moveOnMouseWheel: true },
        ])),
      };
    },
  },
  render() {
    const { option = {}, delay = 800, ...attrs } = this.$attrs;
    return (<Aecharts option={{ ...this.option, ...option }} delay={delay} {...{ attrs }} />);
  }
}